var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn",style:({
    background: _vm.disabled ? _vm.disabledBg : _vm.currentBg,
    color: _vm.disabled ? _vm.defaultColor : _vm.currentColor,
  }),attrs:{"disabled":_vm.disabled || _vm.loading},on:{"click":_vm._click}},[(_vm.loading)?_c('i',{staticClass:"iconfont icon-shuaxin icon"}):_vm._e(),_vm._t("default",function(){return [_vm._v(" 登陆 ")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }